<template>
	<div id="adressBar" class="adressBar">
		<router-link :to="'/'" class="icon-goback"  v-show="isBack"></router-link>
		<div class="adressNav">
			<span class="adress-adress-group" @click="goChooseCity">
				<span class="icon-adress"></span>
				<span class="adressNav-text">{{cityName}}</span>
			</span>
		</div>
		<span class="icon-nav-group" v-show="navBtnShow">
			<span class="icon-nav" @click="navShowClick"></span>
		</span>
	</div>
</template>

<script>
	import Vue from 'vue';
	import { mapState } from 'vuex'
  	import bus from '../../../js/eventBus'
  	
	export default {
		name: 'aressBar',
		props: ['isBack','navBtnShow','goBackLink','navShow'],
		data() {
			return {
        currentCity: '',
        cityName: ''
			}
		},
		computed: mapState({
			navShows: state => state.homeState.navBtnShow
		}),
		components: {
		},
		methods: {
			navShowClick(){
				this.$emit('navShowClick');
			},
			goChooseCity(){
			  console.log(this.goBackLink)
				this.$router.push({'name':'chooseCity',query: { url: this.goBackLink }})
			}
			
		},
    mounted () {
		  var self = this
      var city = eval ("(" + localStorage.getItem('locationCity') + ")")
      if ( city !== null) {
        if (city['name'] !== undefined && city['name'].length > 0) {
          self.cityName = city.name
        } else if (city['cityName'] !== undefined) {
          self.cityName = city.cityName
        }
      }

		  bus.$on('changeCity',function (city) {
		  	console.log(city);

        if ( city !== null) {
          if (city['name'] !== undefined) {
            self.cityName = city.name
          } else if (city['cityName'] !== undefined) {
            self.cityName = city.cityName
          }
        }

      })
    }
	}
</script>

<style lang="scss">
	@import '../../../assets/css/mixin';

	.adressBar {
		padding: 0 pxToRem(30px);
		display: flex;
		justify-content: space-around;
		height: pxToRem(100px);
		line-height: pxToRem(100px);

		&.fixed {
			position: fixed;
		    width: 100%;
		    background: #fff;
		    z-index: 999;
		}
	}

	.adressNav {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		background-color: rgba(255,255,255,0.90);
		font-size: 0;

		.adress-adress-group {

      display: flex;
      align-items: center;
      justify-content: center;

			font-size: pxToRem(24px);
			.icon-adress {
				margin-right: pxToRem(20px);
        width: pxToRem(20px);
			}
      .adressNav-text {

      }
		}

	}

	
</style>


// WEBPACK FOOTER //
// adressBar.vue?675be919